// extracted by mini-css-extract-plugin
export default {"root":"CartComponent_root__iMLwK","counter":"CartComponent_counter__HJUZ7"};